export { default } from "./TextInput-component";
